export default __webpack_public_path__ + "static/media/avatar-twelve.45ef0baa.png";